import { Mixins, Spacing } from "@styles";
import { StyleSheet, Platform, Dimensions } from "react-native";
import { Button } from "@atoms";

export let dHeight, dWidth;

const getDeviceDimensions = () => {
    if (Platform.OS == 'web') {
        const root = document.querySelector('#root');
        if (root) {
            return {
                height: root.clientHeight,
                width: root.clientWidth
            }
        }
    }
    return Dimensions.get('window');
}

const initialSizes = getDeviceDimensions();
dHeight = initialSizes.height;
dWidth = initialSizes.width;

if (Platform.OS == 'web') {
    window.addEventListener('resizeRoot', () => {
        const sizes = getDeviceDimensions();
        dHeight = sizes.height;
        dWidth = sizes.width;
    })
}

export const styles = StyleSheet.create({
    scrollView: {
        flex: 1,
    },
    topBar: {
        height: 48,
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center'
    },
    navBarButton: {
        height: 40,
        ...Mixins.rounding(40),
        alignItems: 'center',
        justifyContent: 'center',
        ...Platform.select({
            native: {}, default: {
                userSelect: 'none'
            }
        }),
        paddingHorizontal: Spacing.M
    },
    noSelect: {
        ...Platform.select({
            native: {},
            default: {
                userSelect: 'none'
            }
        })
    },
    profilePic: {
        width: 40,
        height: 40,
        ...Mixins.rounding(40)
    },
    squaredButton: {
        width: Button.HEIGHT, paddingHorizontal: 0,
    },
    squaredCondensedButton: {
        width: Button.CONDENSED, paddingHorizontal: 0
    },
    noOutline: {
        ...Platform.select({
            native: {},
            default: {
                outlineStyle: 'none'
            }
        })
    }
})